var map = {
	"./gallery_00.jpg": 2118,
	"./gallery_01.jpg": 2119,
	"./gallery_02.jpg": 2120,
	"./gallery_03.jpg": 2121,
	"./gallery_04.jpg": 2122,
	"./gallery_05.jpg": 2123,
	"./gallery_06.jpg": 2124,
	"./gallery_07.jpg": 2125,
	"./gallery_08.jpg": 2126,
	"./gallery_09.jpg": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2117;